// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}

.payment-input {
  margin: 6px 12px;
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  text-transform: uppercase;
}
.header ion-icon {
  width: 25px;
  height: 25px;
}
.header .back-icon {
  width: 20px;
  height: 20px;
}

.header-msg {
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  color: #fff;
}

.payment-method-row {
  --background: transparent;
  align-items: center;
  margin: 6px 12px;
  display: flex;
  flex-direction: column;
  border-radius: 26px;
  border: 1px solid var(--accent-color);
  text-transform: uppercase;
}
.payment-method-row ion-radio {
  --color: var(--accent-color);
  --color-checked: var(--accent-color);
  margin: 11px 16px 10px 4px;
}
.payment-method-row ion-label {
  color: #fff;
  font-family: AppFontMedium;
  text-transform: capitalize;
}

.back-icon {
  margin-right: 10px;
  width: 30px;
}

.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}

.padding-5 {
  padding: 5px;
}

ion-content {
  --background: var(--main-background);
}

.icon-size {
  margin: 0;
  max-width: 120px;
}

.pre-icon-size {
  margin: 0 18px 0 -25px;
  zoom: 0.7;
}

.cash-block {
  display: flex;
  justify-content: center;
}
.cash-block ion-button {
  width: 60%;
  margin: 10px auto;
}

.payment-link {
  width: 100%;
  height: 100%;
  padding: 8px 15px;
  font-size: 16px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
  background: #F48B7F;
  color: white;
  text-decoration: none;
  text-align: center;
  margin-bottom: 30px;
  border-radius: 28px;
}
.payment-link:hover {
  background: #FC5E07;
}

.bottom-separator {
  padding-top: 10px;
}

#customCard-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
#customCard-container label {
  display: flex;
  align-items: center;
  width: 100%;
}
#customCard-container label iframe {
  height: 50px;
}

/* Загальні стилі для картки */
#customCard-container {
  font-family: "Arial", sans-serif;
  padding: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  margin: 0 auto;
}
#customCard-container ion-spinner {
  margin: 0 auto;
}

/* Стилі для полів форми */
#customCard-container .adyen-checkout__field-wrapper {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

#customCard-container .adyen-checkout__label {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}

#customCard-container .adyen-checkout__input {
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background-color: #f9f9f9;
  transition: border-color 0.3s ease-in-out;
}

#customCard-container .adyen-checkout__input:focus {
  border-color: #007bff;
  outline: none;
}

/* Стилі для помилок */
#customCard-container .adyen-checkout__input--error {
  border-color: #ff4d4d;
  background-color: #ffe6e6;
}

#customCard-container .adyen-checkout__error-text {
  color: #ff4d4d;
  font-size: 12px;
  margin-top: 5px;
}

/* Кнопка оплати */
#payButton {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: var(--ion-color-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-top: 10px;
}
#payButton.hidden {
  visibility: hidden;
}

#payButton:hover {
  background-color: #218838;
}

#payButton:active {
  background-color: #1e7e34;
}

/* Відступи та вирівнювання для полів картки */
#customCard-container .adyen-checkout__card__form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

#customCard-container .adyen-checkout__card__form .adyen-checkout__field-wrapper {
  flex: 1;
  min-width: 48%;
}

/* Стілі для основного контейнера */
.payment-modal-container {
  padding: 20px;
}

.payment-modal-container h2 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.payment-modal-container .payment-method {
  margin-bottom: 20px;
}

.payment-modal-container .total-price {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: right;
}

.iframe-wrapper {
  position: relative;
  display: inline-block;
}

.iframe-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.5); /* Напівпрозорий фон */
}

.input_data {
  width: 100%;
}

.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;
  border-bottom: 1px solid var(--color-black);
  border-top: 1px solid var(--color-black);
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #F48B7F;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 14px;
}
.added-gift .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-img {
  width: 45px;
}

.info-section {
  background: var(--ion-color-primary);
  padding: 20px;
  display: flex;
  align-items: center;
}
.info-section ion-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}
.info-section p {
  font-size: 12px;
  color: white;
  text-transform: uppercase;
}

.close-icon {
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.close-icon:hover {
  background: #f2dbd9;
}

.total-sum {
  font-size: 20px;
  margin: 0 15px 0 10px;
  font-weight: 700;
}

.payment-method-icons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.payment-method-icon {
  height: 20px;
  width: auto;
}
.payment-method-icon.visa-icon {
  height: 14px;
}

.total-row-bottom {
  display: flex;
  justify-content: end;
  align-items: center;
  margin: 6px 12px;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,YAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAEF;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;AACE;EACE,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,eAAA;EACA,mCAAA;EACA,gBAAA;EACA,WAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qCAAA;EACA,yBAAA;AADF;AAGE;EACE,4BAAA;EACA,oCAAA;EACA,0BAAA;AADJ;AAIE;EACE,WAAA;EACA,0BAAA;EACA,0BAAA;AAFJ;;AAOA;EACE,kBAAA;EACA,WAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAOA;EACE,SAAA;EACA,gBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,SAAA;AAJF;;AAQA;EACE,aAAA;EACA,uBAAA;AALF;AAOE;EACE,UAAA;EACA,iBAAA;AALJ;;AASA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AARF;AAUE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AARJ;AAUI;EACE,YAAA;AARN;;AAaA,8BAAA;AACA;EACE,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,UAAA;EACA,cAAA;AAVF;AAYE;EACE,cAAA;AAVJ;;AAcA,0BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AAXF;;AAcA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAXF;;AAcA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;AAXF;;AAcA;EACE,qBAAA;EACA,aAAA;AAXF;;AAcA,sBAAA;AACA;EACE,qBAAA;EACA,yBAAA;AAXF;;AAcA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAXF;;AAcA,kBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,gBAAA;AAXF;AAaE;EACE,kBAAA;AAXJ;;AAeA;EACE,yBAAA;AAZF;;AAeA;EACE,yBAAA;AAZF;;AAeA,8CAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAZF;;AAeA;EACE,OAAA;EACA,cAAA;AAZF;;AAeA,mCAAA;AACA;EACE,aAAA;AAZF;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,qBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA,EAAA,sBAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,2CAAA;EACA,wCAAA;AAZF;AAcE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ;AAeI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAbN;AAgBI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAdN;AAkBE;EACE,iBAAA;AAhBJ;AAmBE;EACE,WAAA;AAjBJ;;AAqBA;EACE,oCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,YAAA;EACA,yBAAA;AAnBJ;;AAuBA;EAEE,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AArBF;AAuBE;EACE,WAAA;EACA,YAAA;EACA,WAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;;AAyBA;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,WAAA;AAtBF;AAwBE;EACE,YAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAvBF","sourcesContent":["ion-spinner {\n  margin: 32px;\n  height: 72px;\n  width: 72px;\n}\n\n.payment-input {\n  margin: 6px 12px;\n  border-radius: 5px;\n  padding: var(--ion-margin);\n  color: var(--ion-color-black);\n}\n\n.header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  text-transform: uppercase;\n\n  ion-icon {\n    width: 25px;\n    height: 25px;\n  }\n\n  .back-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.header-msg {\n  font-size: 18px;\n  font-family: Montserrat, sans-serif;\n  font-weight: 600;\n  color: #fff;\n}\n\n.payment-method-row {\n  --background: transparent;\n  align-items: center;\n  margin: 6px 12px;\n  display: flex;\n  flex-direction: column;\n\n  border-radius: 26px;\n  border: 1px solid var(--accent-color);\n  text-transform: uppercase;\n\n  ion-radio {\n    --color: var(--accent-color);\n    --color-checked: var(--accent-color);\n    margin: 11px 16px 10px 4px;\n  }\n\n  ion-label {\n    color: #fff;\n    font-family: AppFontMedium;\n    text-transform: capitalize;\n  }\n\n}\n\n.back-icon {\n  margin-right: 10px;\n  width: 30px;\n}\n\n.bottom-end {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 300px;\n  width: 142px;\n}\n\n.padding-5 {\n  padding: 5px;\n}\n\nion-content {\n  --background: var(--main-background);\n}\n\n.icon-size {\n  margin: 0;\n  max-width: 120px;\n}\n\n.pre-icon-size {\n  margin: 0 18px 0 -25px;\n  zoom: 0.7;\n}\n\n\n.cash-block {\n  display: flex;\n  justify-content: center;\n\n  ion-button {\n    width: 60%;\n    margin: 10px auto;\n  }\n}\n\n.payment-link {\n  width: 100%;\n  height: 100%;\n  padding: 8px 15px;\n  font-size: 16px;\n  font-family: AppFont, sans-serif;\n  text-transform: uppercase;\n  background: #F48B7F;\n  color: white;\n  text-decoration: none;\n  text-align: center;\n\n  margin-bottom: 30px;\n  border-radius: 28px;\n\n  &:hover {\n    background: #FC5E07;\n  }\n}\n\n.bottom-separator {\n  padding-top: 10px;\n}\n\n#customCard-container {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n\n  label {\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    iframe {\n      height: 50px;\n    }\n  }\n}\n\n/* Загальні стилі для картки */\n#customCard-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  border: 1px solid #dcdcdc;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 80%;\n  margin: 0 auto;\n\n  ion-spinner {\n    margin: 0 auto;\n  }\n}\n\n/* Стилі для полів форми */\n#customCard-container .adyen-checkout__field-wrapper {\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n#customCard-container .adyen-checkout__label {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n#customCard-container .adyen-checkout__input {\n  padding: 10px;\n  border: 1px solid #dcdcdc;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #333;\n  background-color: #f9f9f9;\n  transition: border-color 0.3s ease-in-out;\n}\n\n#customCard-container .adyen-checkout__input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n/* Стилі для помилок */\n#customCard-container .adyen-checkout__input--error {\n  border-color: #ff4d4d;\n  background-color: #ffe6e6;\n}\n\n#customCard-container .adyen-checkout__error-text {\n  color: #ff4d4d;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n/* Кнопка оплати */\n#payButton {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  background-color: var(--ion-color-primary);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n  margin-top: 10px;\n\n  &.hidden {\n    visibility: hidden;\n  }\n}\n\n#payButton:hover {\n  background-color: #218838;\n}\n\n#payButton:active {\n  background-color: #1e7e34;\n}\n\n/* Відступи та вирівнювання для полів картки */\n#customCard-container .adyen-checkout__card__form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n#customCard-container .adyen-checkout__card__form .adyen-checkout__field-wrapper {\n  flex: 1;\n  min-width: 48%;\n}\n\n/* Стілі для основного контейнера */\n.payment-modal-container {\n  padding: 20px;\n}\n\n.payment-modal-container h2 {\n  text-align: center;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.payment-modal-container .payment-method {\n  margin-bottom: 20px;\n}\n\n.payment-modal-container .total-price {\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n  text-align: right;\n}\n\n.iframe-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.iframe-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background-color: rgba(255, 255, 255, 0.5); /* Напівпрозорий фон */\n}\n\n.input_data {\n  width: 100%;\n}\n\n.added-gift {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 10px;\n  border-bottom: 1px solid var(--color-black);\n  border-top: 1px solid var(--color-black);\n\n  .header-gift {\n    width: 35px;\n    height: 35px;\n    min-height: 35px;\n    min-width: 35px;\n    background: #F48B7F;\n    border: 1px solid var(--color-black);\n    border-radius: 50%;\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .inner-text-gift {\n    margin-left: 5px;\n\n    h3 {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 14px;\n    }\n\n    p {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n  }\n\n  .delete-items-section {\n    margin-left: auto;\n  }\n\n  ion-img {\n    width: 45px;\n  }\n}\n\n.info-section {\n  background: var(--ion-color-primary);\n  padding: 20px;\n  display: flex;\n  align-items: center;\n\n  ion-icon {\n    width: 45px;\n    height: 45px;\n    margin-right: 10px;\n  }\n\n  p {\n    font-size: 12px;\n    color: white;\n    text-transform: uppercase;\n  }\n}\n\n.close-icon {\n\n  margin: 0px;\n  background: var(--color-white-accent);\n  width: 35px;\n  height: 35px;\n  padding: 0px;\n  z-index: 99;\n\n  ion-icon {\n    width: 100%;\n    height: 100%;\n    margin: 0px;\n  }\n\n  &:hover {\n    background: #f2dbd9;\n  }\n}\n.total-sum {\n  font-size: 20px;\n  margin: 0 15px 0 10px;\n  font-weight: 700;\n}\n\n.payment-method-icons {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.payment-method-icon {\n  height: 20px;\n  width: auto;\n\n  &.visa-icon {\n    height: 14px;\n  }\n}\n\n.total-row-bottom {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  margin: 6px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
